import { useNotification } from "@expert/common-ui";
import { Container, Flex, Overlay, Text, Tooltip } from "@mantine/core";
import { useEffect } from "react";

import { useControlsStore } from "../controls.store";
import styles from "./Dialpad.module.css";
import { DialButtons } from "./elements";

export function Dialpad() {
    const dialpadInput = useControlsStore((state) => state.dialpadInput);
    const isMuted = useControlsStore((state) => state.isMuted);
    const dialpadNotification = useControlsStore((state) => state.dialpadNotification);
    const { setDialpadNotification } = useControlsStore.getState();
    const notification = useNotification();

    useEffect(() => {
        if (isMuted && !dialpadNotification) {
            setDialpadNotification(
                notification.error("Unmute to use dialpad", { persistent: true, position: "top-center" }),
            );
        } else if (!isMuted && dialpadNotification) {
            notification.hide(dialpadNotification);
            setDialpadNotification(undefined);
        }
        // oxlint-disable-next-line exhaustive-deps
    }, [isMuted, dialpadNotification]);

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement) return;
            if (/[^#*0-9]/.test(event.key)) return;
            handleKey(event.key);
        };

        document.addEventListener("keydown", handleKeyDown);

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
        // oxlint-disable-next-line exhaustive-deps
    }, [dialpadInput]);

    const handleKey = (key: string) => {
        useControlsStore.getState().setDialpadInput(dialpadInput + key);
    };

    function truncateString(str: string) {
        if (str.length > 10) {
            return `...${str.slice(-10)}`;
        }
        return str;
    }

    return (
        <Container bg="var(--exwo-color-control-bar-bg)" classNames={{ root: styles.containerRoot }}>
            {isMuted ? (
                <Tooltip.Floating label="Disabled while muted" color="dark.7" fz="xs">
                    <Overlay
                        color="var(--exwo-color-control-bar-bg)"
                        backgroundOpacity={0.6}
                        zIndex="var(--mantine-priority-highest)"
                        classNames={{ root: styles.overlay }}
                    />
                </Tooltip.Floating>
            ) : null}
            <Flex align="center" direction="column" justify="center" mih={56} p="sm" wrap="wrap">
                <Text classNames={{ root: styles.textRoot }} size="lg">
                    <b>{truncateString(dialpadInput)}</b>
                </Text>
            </Flex>
            <DialButtons />
        </Container>
    );
}
